import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ThemeProcessorService } from './theme-processor.service';
import { LocalStorage } from '@app/models/constants';

@Injectable({
	providedIn: 'root'
})
export class ThemeDisplayService {
	constructor(private themeProcessor: ThemeProcessorService) {}

	refreshTheme() {
		if (localStorage.getItem(LocalStorage.MARKET) != null && localStorage.getItem(LocalStorage.TOOLS) != null) {
			this.displayMarketTheme(
				localStorage.getItem(LocalStorage.MARKET).toLowerCase(),
				localStorage.getItem(LocalStorage.TOOLS).toLowerCase()
			);
		}
	}

	displayMarketTheme(market: string, tool: string) {
		if (
			(market && localStorage.getItem(LocalStorage.MARKET) !== market) ||
			(tool && localStorage.getItem(LocalStorage.TOOLS) !== tool)
		) {
			this.themeProcessor.changeTheme(market, tool);
		}
	}

	displayMarketThemeFromRoute(routeSnapshot: ActivatedRouteSnapshot) {
		const urlSegmentMarketList = routeSnapshot?.url?.filter((url) => url.path === 'b2c' || url.path === 'b2b');

		if (urlSegmentMarketList.length > 0 && urlSegmentMarketList[0]?.path) {
			//TODO: clarify for the tool part
			this.displayMarketTheme(urlSegmentMarketList[0]?.path, localStorage.getItem(LocalStorage.TOOLS));
		}
	}
}
